<template>
  <div>
    <div class="bg">
      <FxedTop></FxedTop>
      <div class="page">
        <div class="pageTitle">
          <div class="sort"></div>
          <div class="currentLocation">
            当前位置：首页 > 动态资讯 >
            {{ $route.query.type == 1 ? "常见问题" : "文章详情" }}
          </div>
        </div>
        <div class="mian">
          <div class="container">
            <div v-if="result" class="content" v-html="result.contentHtml"></div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import * as cmsApi from "@/api/cms";
export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      result: [],
    };
  },
  created() {
    this.getIndex();
    this.$route.query.type = 1;
  },
  methods: {
    async getIndex() {
      let article = await cmsApi.getArticleDetails({
        articleId: this.$route.query.articleId,
      });
      this.result = article.result;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  box-sizing: border-box;
  min-height: 450px;
}

.container {
  width: 100%;
  background: #fff;
  // 强制换行
  border-radius: 10px;
  font-size: 16px;
}
</style>
